<template>
  <v-container>
    <div>
      <v-flex>
        <v-row>
          <h1 class="page-title">Administrators</h1>
          <v-spacer class="line"></v-spacer>
          <hr />
          <new-user-modal>
            <v-btn
              tile
              small
              class="primary dropdown-menu-activator"
              depressed
              ><v-icon left>mdi-plus</v-icon>Add User
            </v-btn>
          </new-user-modal>
        </v-row>
      </v-flex>
      <v-row>
        <v-col class="col-sm-8 pl-0">
        </v-col>
        <v-col class="col-sm-4 pr-0">
          <v-text-field
            solo
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
            v-model="searchData"
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      
      <v-card :loading="localLoading">
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Email</th>
              <th style="width: 170px">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="person of usersSearched" :key="person.id">
              <td>
                {{ person.full_name }}
              </td>
              <td>
                {{ person.email }}
              </td>
              <td>
                <edit-user-modal
                  :thisUserData="person"
                  @userUpdated="editedUser"
                  style="display:inline;"
                >
                  <v-btn small color="primary" tile depressed>
                    Edit User
                  </v-btn>
                </edit-user-modal>
                
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn tile small class="primary dropdown-menu-activator" depressed v-on="on">
                      <v-icon>mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="onDeleteUser(person)">
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as _ from "lodash";
import EditUserModal from "./EditUserModal";
import NewUserModal from "./NewUserModal";

export default {
  name: "Users",
  components: {
    "edit-user-modal": EditUserModal,
    "new-user-modal": NewUserModal,
  },
  data: () => ({
    localLoading: false,
    // --
    searchData: null,
  }),
  mounted() {
    this.fetchUsers();
    this.fetchAreas();
    this.fetchRestaurants();
  },
  created() {
    // --
  },
  computed: {
    ...mapGetters("user", {
      users: "users",
    }),
    usersSearched() {
      let result = this.users;

      if (!_.isEmpty(this.searchData)) {
        result = _.filter(result, (p) => p.full_name.indexOf(this.searchData) !== -1 || p.email.toLowerCase().indexOf(this.searchData) !== -1);
      }

      return result;
    },
  },
  methods: {
    ...mapActions("user", [
      "fetchUsers", "deleteUser"
    ]),
    ...mapActions([
      "fetchAreas", "fetchRestaurants"
    ]),
    onDeleteUser(user) {
      if (!confirm("Remove user " + user.full_name + "?")) {
        return; // exit
      }

      this.localLoading = true;
      this.deleteUser(user)
        .then(() => {
          //
        })
        .finally(() => {
          this.localLoading = false;
        });
    },
    clearSearch() {
      this.searchData = null;
    },
    editedUser(/*payload*/) {
      this.clearSearch();
    },
  },
};
</script>

<style scoped>
</style>